import OStepIcon from './o-step-icon';

export default OStepIcon;